import { RootState } from '@redux/store';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { _updatePrevCounterTopAreaQty } from './pricedProductSlice.utils';

interface PricedProductState {
    /**
     * Used to keep the old value of countertopAreaQty and the new value of counterTopAreaQty
     */
    prevCounterTopAreaQty: Set<number>;
}

const initialState: PricedProductState = {
    prevCounterTopAreaQty: new Set(),
};

const pricedProductsSlice = createSlice({
    name: 'pricedProducts',
    initialState,
    reducers: {
        resetCountertopAreaQuantity: (state): PricedProductState => ({
            ...state,
            prevCounterTopAreaQty: initialState.prevCounterTopAreaQty,
        }),
        updatePrevCounterTopAreaQty: (
            state: PricedProductState,
            action: PayloadAction<number>
        ): PricedProductState => ({
            ...state,
            prevCounterTopAreaQty: _updatePrevCounterTopAreaQty(state.prevCounterTopAreaQty, action.payload),
        }),
    },
});

export const selectPrevCounterTopAreaQty = ({ pricedProducts }: RootState): Set<number> =>
    pricedProducts.prevCounterTopAreaQty;

export const { resetCountertopAreaQuantity, updatePrevCounterTopAreaQty } = pricedProductsSlice.actions;

export default pricedProductsSlice.reducer;
